/**
 * Created by lu on 2018/5/24.
 * 消息item
 */
var nb = require('../../nb');
module.exports = nb.define({
    view: {
        'class': 'msg-item',
        'data-isRead': nb.bind('isRead'),
        'data-type': nb.bind('type'),
        'data-status': nb.bind('status'),
        $html: [{
            'class': 'iconfont icon-sysInfo-copy'//image
            // $html: [{
            //     tag: 'img',
            //     src: nb.bind('icon') //icon
            // }]
        }, {
            'class': 'info',
            $html: [{
                'class': 'msg-title',
                $html: [{
                    tag: 'span',
                    'class': 'msg-type',
                    $text: nb.bind('crtName') //  msgType
                }, {
                    tag: 'span',
                    'class': 'msg-time',
                    $text: nb.bind('crtTime')  //  time
                }]
            }, {
                'class': 'msg-sub-title uk-text-truncate',
                $html: nb.bind('content')  //subTitle
            }]

        }
            // ,{
            //     'class':'msg-content',
            //     $html:[{
            //
            //     }]
            // }
        ]
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/view/notice/MsgItem.js
// module id = 28
// module chunks = 0 1 2 3 4 7 8 9 10 12 13 14 15 16 18 19 20 21 22 23 25 26 27 28 29 30 34